// Ícono oficial de Tienda Nube — solo el símbolo (la nube), sin el wordmark.
// Usa `currentColor` para tomar el color del texto (className `text-*`), así se
// pinta acorde al estilo ATLAS. Extraído del logo oficial (CC).

import React from "react";

export const TiendaNubeIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    viewBox="0 0 139.2 100"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M89.1 0H89C75.9 0 63.5 5.1 54.2 14.2c-4.7-2-9.9-3.1-15.2-3.1C17.6 11.1.1 28.5.1 50S17.5 88.9 39 88.9c5.2 0 10.4-1.1 15.1-3.1 9 8.8 21.3 14.2 34.8 14.2 27.6 0 50-22.4 50-50 .1-27.5-22.3-50-49.8-50zM89 88.9c-21.4 0-38.9-17.4-38.9-38.9H39c0 9.8 2.8 19 7.7 26.7-2.5.7-5.1 1.1-7.7 1.1-15.3 0-27.8-12.5-27.8-27.8S23.7 22.2 39 22.2c6.1 0 11.8 1.9 16.7 5.6 7.1 5.3 11.1 13.4 11.1 22.2H78c0-11.6-5-22.4-13.9-29.8 7-5.8 15.8-9.1 25-9.1 21.4 0 38.9 17.5 38.9 38.9-.1 21.4-17.5 38.9-39 38.9z" />
  </svg>
);

export default TiendaNubeIcon;
